var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ckeditor"},[_c('textarea',{attrs:{"id":_vm.id,"disabled":_vm.editorDisabled},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }